import { Injectable } from '@angular/core';
import { Http, URLSearchParams } from '@angular/http';

import { Observable, timer } from 'rxjs';
import { map, switchMap, share } from 'rxjs/operators';

import { Notification } from 'app/notifications/notification';
import { PersonalizedLocalStorageService } from 'app/notifications/personalized-local-storage.service';

interface Mixpanel {
    config: {
        token: string;
    },
    people: {
        append(properties: any): void;
    },
    set_config(config: any): void;
    get_distinct_id(): string;
    track(action: string, properties: any): void;
}

@Injectable()
export class MixpanelNotificationsSource {

    private mixpanel: Mixpanel = <Mixpanel>(<any>window).mixpanel;

    constructor(private httpClient: Http,
        private localStorageService: PersonalizedLocalStorageService) {
        this.mixpanel.set_config({ disable_notifications: true });
    }

    getNotifications(): Observable<Notification[]> {
        return timer(0, 10000)
            .pipe(
                switchMap(() => this.loadNotifications()),
                share()
            );
    }

    markAsRead(notifications: Notification[]) {
        for (const notification of notifications) {
            this.setLocalProperty(notification, { isRead: true });
        }
    }

    close(notification: Notification) {

        // this.setLocalProperty(notification, { isClosed: true });

        const action = '$campaign_delivery';
        const properties = {
            campaign_id: notification.type,
            message_id: notification.id,
            message_type: 'web_inapp',
            message_subtype: 'takover'
        };
        this.mixpanel.track(action, properties);

        this.mixpanel.people.append({
            $campaigns: notification.type,
            $notifications: {
                campaign_id: notification.type,
                message_id: notification.id,
                type: 'web',
                time: new Date()
            }
        });
    }

    private setLocalProperty(notification, changes) {
        const key = this.createKey(notification);
        const props = this.localStorageService.getJson(key) || {};
        for (const prop of Object.keys(changes)) {
            notification[prop] = changes[prop];
            props[prop] = changes[prop];
        }
        this.localStorageService.setJson(key, props);
    }

    private loadNotifications(): Observable<Notification[]> {
        const params = new URLSearchParams();
        params.append('version', '2');
        params.append('lib', 'web');
        params.append('token', this.mixpanel.config.token);
        params.append('distinct_id', this.mixpanel.get_distinct_id());
        return this.httpClient
            .get('https://api.mixpanel.com/decide', { params })
            .pipe(map(response => this.createNotifications(response)));
    }

    private createNotifications(notificationsResponse): Notification[] {
        return notificationsResponse
            .json()
            .notifications
            .map(notificationResponse => this.createNotification(notificationResponse))
            .filter(notification => !notification.isClosed);
    }

    private createKey(notification: Notification) {
        return `${notification.type}-${notification.id}`;
    }

    private createNotification(notificationResponse): Notification {
        const notification = {
            id: notificationResponse.message_id,
            type: notificationResponse.id,
            title: notificationResponse.title,
            body: notificationResponse.body,
            button: notificationResponse.cta,
            buttonAction: notificationResponse.cta_url,
            isRead: false,
            isClosed: false
        };
        const key = this.createKey(notification);
        const props = this.localStorageService.getJson(key) || {};
        Object.assign(notification, props);
        return notification;
    }
}